// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"80":"e6ef0e19","353":"6dcaf796","453":"5a1f9a76","759":"90c5530f","901":"90542711","982":"a74b5182"}[chunkId] + ".chunk.js";
};